import { mergeTailwindClasses } from '@xefi/x-react/utils';

type NotificationBadgeProps = {
   count: number;
   isActive?: boolean;
   animated?: boolean;
   className?: string;
   maxCount?: number;
};

export const NotificationBadge = ({
   count = 0,
   isActive = false,
   animated = false,
   className,
   maxCount = 99,
}: NotificationBadgeProps) => {
   const displayValue =
      maxCount !== undefined && count > maxCount
         ? `${maxCount}+`
         : count.toString();

   const shouldAnimate = animated && !isActive && count > 0;

   return (
      <div
         className={mergeTailwindClasses(
            'relative flex transform-gpu cursor-default items-center justify-center rounded-full text-xs leading-none font-bold transition-all duration-200 ease-out select-none',
            isActive
               ? 'bg-primary border border-white/40 text-white'
               : 'bg-gray-200 text-gray-700',
            shouldAnimate && 'border-white/40 text-white',
            displayValue.length < 3
               ? 'size-[24px]'
               : 'h-[24px] min-w-[24px] px-1.5',
            className,
         )}
      >
         {displayValue}
         {shouldAnimate && (
            <div className='bg-primary absolute inset-0 -z-10 animate-ping rounded-full opacity-75' />
         )}
      </div>
   );
};
